module.exports = "/client/favicon.ico";